import useReveal from "@/hooks/useReveal";
import { work } from "@/lib/home-content";

function Card({ item, i }) {
    const { ref, visible } = useReveal({ threshold: 0.08 });

    return (
        <article
            ref={ref}
            style={{ transitionDelay: `${(i % 3) * 70}ms` }}
            className={`reveal flex h-full flex-col overflow-hidden rounded-2xl bg-white shadow-[0_10px_30px_rgba(15,23,42,0.05)] ring-1 ring-black/5 ${
                visible ? "is-visible" : ""
            }`}
        >
            <img
                src={`/work/${item.id}.jpg`}
                alt={`${item.name} homepage`}
                className="aspect-[16/10] w-full object-cover object-top"
            />
            <div className="flex flex-1 flex-col p-6">
                {item.concept ? (
                    <span className="mb-4 inline-flex w-fit items-center rounded-full bg-white px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-[#3f3f46] ring-1 ring-[#e4e4e7]">
                        Template
                    </span>
                ) : null}
                <h3 className="font-display text-[1.35rem] font-bold leading-tight text-[#0a0a0b]">{item.name}</h3>
                <p className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#8a8a95]">{item.meta}</p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-[#5b5b66]">{item.description}</p>
                <a
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-5 inline-flex w-fit items-center gap-1 border-b border-[#0a0a0b] pb-0.5 text-sm font-medium text-[#0a0a0b] transition-colors hover:border-[var(--brand)] hover:text-[var(--brand)]"
                >
                    View website
                    <span aria-hidden="true">→</span>
                </a>
            </div>
        </article>
    );
}

export default function Work() {
    const { ref, visible } = useReveal();

    return (
        <section id="work" data-testid="work-section" className="bg-white px-5 py-16 sm:py-20">
            <div className="mx-auto max-w-6xl">
                <div ref={ref} className={`reveal max-w-3xl ${visible ? "is-visible" : ""}`}>
                    <span className="section-kicker">{work.kicker}</span>
                    <h2 className="section-title">{work.title}</h2>
                    <p className="section-lead">{work.subtitle}</p>
                </div>
                <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {work.items.map((item, i) => (
                        <Card key={item.id} item={item} i={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
